import { AmountChangeEvent, DealGroupingChangeEvent } from '../types/api/deals';
export const THIRTY_DAYS_IN_MS = 2592000000;
export const TEN_MIN_IN_MS = 600000;
export const NEW = 'NEW';
export const SUCCESS = 'success';
export const DEAL_AMOUNT = 'dealAmount';
export const DEAL_STAGE = 'dealStage';
const REMOVED_USE_KEYWORD = 'removed';
export const DEAL_HISTORY_INFO = {
  dealAmount: {
    [AmountChangeEvent.NEW]: {
      useKeyWord: SUCCESS,
      i18nKey: 'dealTable.propertyChange.dealAmountAdded',
      tooltipText: 'dealTable.propertyChange.dealAmountAdded'
    },
    [AmountChangeEvent.REMOVED]: {
      useKeyWord: REMOVED_USE_KEYWORD,
      i18nKey: 'dealTable.propertyChange.dealAmountRemoved',
      tooltipText: 'dealTable.propertyChange.dealAmountRemoved'
    },
    [AmountChangeEvent.INCREASE]: {
      useKeyWord: undefined,
      tooltipText: 'dealTable.propertyChange.dealAmountChangeTooltipIncrease',
      i18nKey: undefined
    },
    [AmountChangeEvent.DECREASE]: {
      i18nKey: undefined,
      useKeyWord: undefined,
      tooltipText: 'dealTable.propertyChange.dealAmountChangeTooltipDecrease'
    },
    [AmountChangeEvent.UNCHANGED]: {
      i18nKey: undefined,
      useKeyWord: undefined,
      tooltipText: undefined
    },
    [AmountChangeEvent.MISSING]: {
      i18nKey: undefined,
      useKeyWord: undefined,
      tooltipText: undefined
    }
  },
  dealStage: {
    [DealGroupingChangeEvent.NEW]: {
      useKeyWord: SUCCESS,
      i18nKey: 'dealTable.propertyChange.dealStageAdded',
      tooltipText: 'dealTable.propertyChange.dealStageAdded'
    },
    [DealGroupingChangeEvent.ADVANCE]: {
      useKeyWord: SUCCESS,
      i18nKey: 'dealTable.propertyChange.dealStageAdvanced',
      tooltipText: 'dealTable.propertyChange.dealStageChangeTooltipMoveForward'
    },
    [DealGroupingChangeEvent.REMOVED]: {
      useKeyWord: REMOVED_USE_KEYWORD,
      i18nKey: 'dealTable.propertyChange.dealStageRemoved',
      tooltipText: 'dealTable.propertyChange.dealStageRemoved'
    },
    [DealGroupingChangeEvent.REGRESS]: {
      useKeyWord: REMOVED_USE_KEYWORD,
      i18nKey: 'dealTable.propertyChange.dealStageRegressed',
      tooltipText: 'dealTable.propertyChange.dealStageChangeTooltipMoveBackward'
    },
    [DealGroupingChangeEvent.UNCHANGED]: {
      useKeyWord: undefined,
      i18nKey: undefined,
      tooltipText: undefined
    },
    [DealGroupingChangeEvent.MISSING]: {
      useKeyWord: undefined,
      i18nKey: undefined,
      tooltipText: undefined
    }
  }
};